import { IDataEntryForm } from '../models/data-entry.model';
import { FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import moment from 'moment';
import { ILinkbox } from '../models/linkbox.model';
import { ILinkboxCard } from '../models/linkbox.model';
import { ZpDataService } from './../services/zp-data.service';


export class DynamicHelpers {
  static zenplansData: any;
  constructor(private zenplansData: ZpDataService) { }
  
  public static clearHiddenFieldValues(formTemplate: IDataEntryForm, formGroup: FormGroup) {
    formTemplate.fields.forEach(kk => {
      if (kk.showFields) {
        if (kk.inputtype == "radiobuttonsshow") {
          kk.options.forEach(option => {
            if (option["option"] == formGroup.value[kk.fieldid] &&
              option["action"] == "hide") {
              //The user may have chosen hide, leaving data in the hidden objects.
              //lets erase any hidden data in the showFields list
              kk.showFields.map(fieldId => {
                formGroup.value[fieldId] = "";
              });
            }
          })
        }

        if (kk.inputtype == "yesnotogglehideshow") {
          kk.urlparameters.forEach(param => {
            if (param["option"] != formGroup.value[kk.fieldid]) {
              //The user may have chosen hide, leaving data in the hidden objects.
              //lets erase any hidden data in the urlparameters list
              param.urlArray.forEach(url => {
                formGroup.value[url] = "";
              })
            }
          });
        }

      }

      if (kk.inputtype == "formarray") {
        //remove array members that are empty
        let removeItems: number[] = [];
        let itemList = formGroup.value[kk.fieldid] as string[];
        if (!itemList) { return; }
        itemList.map((item, index) => {
          if (item == null || item == "") {
            removeItems.push(index);
          }
        });
        removeItems.map(myIndex => {
          itemList.splice(myIndex, 1);
        });
      }

    });
  }

  public static findInvalidControls(form: FormGroup) {
    const invalid = [];
    const controls = form.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  public static getExpireDate(reviewValue) {
    let now = new Date();
    switch (reviewValue) {
      case "3 months": {
        return moment().add(3, 'month')
      }
        break;
      case "6 months": {
        return moment().add(6, 'month')
      }
        break;
      case "12 months": {
        return moment().add(12, 'month')
      }
        break;
      case "18 months": {
        return moment().add(18, 'month')
      }
        break;
      case "24 months": {
        return moment().add(24, 'month')
      }
        break;
    }
  }

  public static async getItemCount(fatherName, userId) {
    var http: HttpClient;
    var counter: number = 0;
    //var zendata = new ZpDataService();
    let template = await http.get<ILinkbox>("assets/formtemplates/" + fatherName + ".json").toPromise();
    if (template) {
      template.cards.map(async card => {
        counter += await this.getItemCount(card.title, userId);
      })
    }
    else {
      return await this.zenplansData.getSectionItemCount(fatherName, userId);
    }
    return counter;
  }

  // public static async addInsuranceToProperty(insuranceId,propertyId,clientId){
  //   //when a user adds a property to an insruance, we will add the isnurance to the property
  //   //Check if the insurance is already connected to the property
  //   let myProperty = await this.zenplansData.getItem(propertyId, "property", clientId);
  //   if(!myProperty["propertyInsurances"] || !myProperty["propertyInsurances"].includes(insuranceId)){
  //     if(!myProperty["propertyInsurances"]){
  //       myProperty["propertyInsurances"] = [];
  //       myProperty["propertyHasInsurances"] = true;
  //     }
  //     myProperty["propertyInsurances"].push(insuranceId);
  //     this.zenplansData.updateItem(myProperty,"property");
  //     return true;
  //   }
  //   return false;
  // }

  // async canEdit(myUser, sectionTitle) {
  //   let retval = false
  //   if (myUser.sharedPlanUserId) { //a delegate is looking at this info
  //     let categoryName = await this.zenplansData.getPlanCategory(sectionTitle);
  //     if (!categoryName) { return; }
  //     switch (categoryName) {
  //       case "my assets":
  //         if (myUser.delegate["assetsPermission"]=="contributor") {
  //           retval = true;
  //         }
  //         break;
  //       case "my debts":
  //         if (myUser.delegate["debtsPermission"]=="contributor") {
  //           retval = true;
  //         }
  //         break;
  //       case "my daily life":
  //         if (myUser.delegate["dailyLifePermission"]=="contributor"){
  //           retval = true;
  //         }
  //         break;
  //       case "my wishes":
  //         if (myUser.delegate["wishesPermission"]=="contributor"){
  //           retval = true;
  //         }
         
  //         break;
  //     }
  //     return retval;
  //   }
  //   else{ //the client himself is deleting
  //     return true;
  //   }
  // }


}
